__turbopack_context__.v({
  "Field": "index-module__JyVBJa__Field",
  "Item": "index-module__JyVBJa__Item",
  "ItemIndicator": "index-module__JyVBJa__ItemIndicator",
  "ItemText": "index-module__JyVBJa__ItemText",
  "Label": "index-module__JyVBJa__Label",
  "Popup": "index-module__JyVBJa__Popup",
  "Positioner": "index-module__JyVBJa__Positioner",
  "Select": "index-module__JyVBJa__Select",
  "Value": "index-module__JyVBJa__Value",
});
